<template>
  <div id="base-autocomplete-product">
    <v-autocomplete
      :items="products"
      :value="productNameByValue"
      @input="findId"
      clearable
      item-text="productname"
      item-value="productname"
      label="Product"
      v-bind="$attrs"
    ></v-autocomplete>
  </div>
</template>

<script>
import _ from 'lodash/orderBy'
export default {
  name: '',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      productNameByValue: ''
    }
  },
  watch: {
    value() {
      this.value
        ? this.findName(this.value) // editing
        : (this.productNameByValue = '') // craeting
    }
  },
  computed: {
    products() {
      return _(
        this.$store.state.Product.products,
        ['id', 'orders'],
        ['asc', 'asc']
      )
    }
  },
  methods: {
    findName(value) {
      this.productNameByValue = this.products.find(
        item => item.productid == value
      ).productname
    },
    findId(productName) {
      let productId = this.products
        .filter(item => item.productname == productName)
        .map(item => item.productid)
        .toString()
      this.$emit('input', productId)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/BaseAutocompleteProduct.vue